import React from 'react';
import ViewportContext from './ViewPortContext';

const ViewportProvider = ({ children }: { children: React.ReactNode }) => {
  const [viewportDt, setViewportDt] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const handleWindowResize = () => {
    setViewportDt({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  React.useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return <ViewportContext.Provider value={viewportDt}>{children}</ViewportContext.Provider>;
};

export default ViewportProvider;
